import API from '../api/index.ts';
import MainClass, { MAIN_CLASS_PARAMS } from '../utils/mainClass.ts';
import Popup from './Popup.ts';

class Button extends MainClass {
	constructor( options: MAIN_CLASS_PARAMS ) {
		super( options );
		this.selector && this.init();
	}
	renderPopup = ( popupStringHtml: string ) => {
		const bodyEle = document.body;
		bodyEle.insertAdjacentHTML( 'beforeend', popupStringHtml.replace( /is-layout-flow/g, '' ) );
        bodyEle.classList.add('overflow-hidden')
		const popup = document.querySelector( '.raise-popup' );
		popup?.classList.add( 'opacity-100' );
		if ( popup ) {
			const popupMethod = new Popup( {
				item: popup,
			} );
			popupMethod.handleClosePopup();
		}
	};
	getPopup = async ( popupId: number | string ) => {
		try {
			const ApiMethod = new API( { feature: 'wp/v2' } );
			const dataPopup = await ApiMethod.getApi( `wp/v2/popup/${ popupId }` );
			if ( dataPopup ) {
				return dataPopup;
			}
			return {};
		} catch ( error ) {
			return {};
		}
	};
	init() {
		if ( this.selector?.classList.contains( 'buttonHasPopup' ) ) {
			this.selector.addEventListener( 'click', e => {
				e.preventDefault();
				const popupId = this.selector.dataset.popupId;
				if ( popupId ) {
					this.getPopup( popupId ).then( popup => {
						this.renderPopup( popup?.content?.rendered );
					} );
				}
			} );
		}
	}
}

export default Button;
